import React, { FC } from 'react';

export interface PageProps {
  className: string;
}

const Page: FC<PageProps> = ({ children, className }) => (
  <div className={`${className} w-full h-full`}>{children}</div>
);

export default Page;
